import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { ACCOUNT_USER_PAGE_NAME } from '../../../constants/service/app/accountUserConstants';
import AccountUserRankListContainer from '../../../containers/account/user/AccountUserRankListContainer';

const AccountUserRankList = () => {
  return (
    <PageTemplate pageName={ACCOUNT_USER_PAGE_NAME.USER_RANK}>
      <AccountUserRankListContainer pageName={ACCOUNT_USER_PAGE_NAME.USER_RANK} />
    </PageTemplate>
  );
};

export default AccountUserRankList;
